module.exports = __webpack_public_path__ + "img/20191223132518427.94b2b6c9.jpg";